// extracted by mini-css-extract-plugin
export default {"nav":"Layout_nav__DQOXF"};